import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

// ===========================================
// Config Service - App Configuration
// ===========================================

interface SyncProjectTypesResult {
  success: boolean;
  projectTypes: string[];
  error?: string;
}

interface DeleteResult {
  success: boolean;
  deletedCount: number;
  error?: string;
}

interface DeleteUsersResult extends DeleteResult {
  deletedUsers?: string[];
  preservedUsers?: string[];
}

/**
 * Manually trigger project type sync from Portal
 * Requires admin or owner role
 */
export async function syncProjectTypes(): Promise<SyncProjectTypesResult> {
  const callable = httpsCallable<void, SyncProjectTypesResult>(
    functions,
    'crm_syncProjectTypesManual'
  );

  const result = await callable();
  return result.data;
}

/**
 * Delete all test projects from Firestore
 * OWNER ONLY - requires owner role
 * WARNING: This deletes ALL projects, use with caution
 */
export async function deleteAllProjects(): Promise<DeleteResult> {
  const callable = httpsCallable<void, DeleteResult>(
    functions,
    'crm_deleteAllProjects'
  );

  const result = await callable();
  return result.data;
}

/**
 * Delete test/seeded users from Firestore and Firebase Auth
 * OWNER ONLY - requires owner role
 * Preserves active users, deletes invited/inactive users
 */
export async function deleteTestUsers(): Promise<DeleteUsersResult> {
  const callable = httpsCallable<void, DeleteUsersResult>(
    functions,
    'crm_deleteTestUsers'
  );

  const result = await callable();
  return result.data;
}
